import { ConsoleLogger } from "amazon-chime-sdk-js";
import { SDK_LOG_LEVELS } from "./constants";
import { MeetingConfig } from "./types";

export const meetingConfig: MeetingConfig = {
  simulcastEnabled: false,
  logger: new ConsoleLogger("PollinatorVideo", SDK_LOG_LEVELS.error),
};

export default meetingConfig;
